import React, { FC, useEffect } from 'react';
import AdminPageCmp from '../../components/AdminPage';
import AdminUserModal from '../../components/AdminPage/AdminUserModal';
import Modal, { Sheets, ModalHeader, ModalBody } from '@ingka/modal';
import Stack from '@mui/material/Stack';
import Button from '@ingka/button';
import { useDispatch } from 'react-redux';
import { useTypedSelector } from '../../store';
import { selectAdminUsers } from '../../store/users/selectors';
import { FormProvider, useForm } from 'react-hook-form';

import { yupResolver } from '@hookform/resolvers/yup';
import { modalsActions } from '../../store/modals/slice';
import { userValidation } from '../../utils/validation';
import { selectDataActions } from '../../store/selectData/slice';
import { deleteUser, updateUser } from '../../store/users/actionWrappers';
import { userDetailsActions } from '../../store/users/slice';
import useTranslation from '../../hooks/useTranslation';
import { selectCountriesByUserPermissions } from '../../store/selectData/selectors';
import skapaColours from '@ingka/variables/colours-css';
import {
  selectViewUserId,
  selectViewUserModal,
} from '../../store/modals/selectors';
import {
  selectUserEmail,
  selectUserRole,
} from '../../store/userData/selectors';
import { AD, SA, PC } from '../../components/RoleRestricted/utils';

const AdminPage: FC = () => {
  const dispatch = useDispatch();
  const t = useTranslation();
  const userDetails = useTypedSelector(selectAdminUsers);
  const viewUserModal = useTypedSelector(selectViewUserModal);
  const user = useTypedSelector(selectViewUserId);
  const currentUserRole = useTypedSelector(selectUserRole);
  const LoggedInUser = useTypedSelector(selectUserEmail);
  const formMethods = useForm({
    resolver: yupResolver(userValidation(t)),
  });

  useEffect(() => {
    dispatch(userDetailsActions.fetchUsers());
    dispatch(selectDataActions.fetchBusinessUnits());
  }, []);

  useEffect(() => {
    if (user) {
      reset(user);
    }
  }, [user]);

  const closeUserModal = () => {
    dispatch(modalsActions.closeViewUserModal());
    reset();
  };

  const onDelete = (data) => {
    if (user) {
      dispatch(deleteUser(data));
      closeUserModal();
    }
  };

  const { reset, handleSubmit } = formMethods;
  //HANDLE BU HIERARCHY
  const countries = useTypedSelector(selectCountriesByUserPermissions);
  const onSubmit = (data) => {
    if (user) {
      data.countries = data.countries?.map((cu) => {
        if (cu?.countryId) return cu?.countryId;
        return cu;
      });

      dispatch(updateUser(data));

      closeUserModal();
    }
  };

  const canDeleteUser =
    (currentUserRole === AD && user?.expansionUserRole === PC) ||
    (currentUserRole === SA && user?.expansionUserRole !== SA);

  return (
    <>
      <Modal visible={viewUserModal} handleCloseBtn={closeUserModal}>
        <Sheets
          alignment={'right'}
          size={'medium'}
          header={
            <ModalHeader
              title={user ? t('admin.updateUser') : t('admin.addUser')}
              floating={false}
            />
          }
          footer={null}
        >
          <ModalBody>
            <FormProvider {...formMethods}>
              <form noValidate>
                <AdminUserModal
                  countries={countries}
                  userEmail={user?.email}
                  userRole={user?.expansionUserRole}
                  currentUserRole={currentUserRole}
                  loggedInUserEmail={LoggedInUser}
                />
                <Stack
                  alignItems="center"
                  justifyContent="center"
                  flexDirection="row"
                  marginTop={2}
                  width={1}
                >
                  <Button
                    fluid
                    text={t('admin.updateUser')}
                    type="primary"
                    htmlType="submit"
                    onClick={handleSubmit(onSubmit)}
                  />
                  {canDeleteUser ? (
                    <Button
                      text={'Delete User'}
                      className={'button-border_red'}
                      style={{
                        color:
                          skapaColours.colourInteractiveDestructiveBgDefault,
                        width: '100%',
                        marginLeft: '5rem',
                      }}
                      type={'secondary'}
                      onClick={handleSubmit(onDelete)}
                    />
                  ) : null}
                </Stack>
              </form>
            </FormProvider>
          </ModalBody>
        </Sheets>
      </Modal>
      <AdminPageCmp review={false} userDetails={userDetails} />
    </>
  );
};

export default AdminPage;
